import { CommonModule } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { QRCodeComponent } from 'angularx-qrcode'
import { QrCodeWidget } from 'libs/gb-dashboard/presenter/data-access-presenter-widgets/src/lib/+state/presenter-widgets.models'
import { GbPresenterColorResolverService } from 'libs/gb-dashboard/presenter/utils/src/lib/gb-presenter-color-resolver.service'

@Component({
  selector: 'gb-presenter-widget-qr-code',
  imports: [CommonModule, QRCodeComponent],
  templateUrl: './gb-presenter-widget-qr-code.component.html',
  styleUrl: './gb-presenter-widget-qr-code.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterWidgetQrCodeComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Input({ required: true }) qrCodeWidget!: QrCodeWidget
  @ViewChild('qrCodeBody') qrCodeBody?: ElementRef<HTMLDivElement>

  qrCodeSize = 1
  private resizeObserver?: ResizeObserver

  constructor(
    private cdr: ChangeDetectorRef,
    private colorResolver: GbPresenterColorResolverService,
  ) {}

  get backgroundColor(): string {
    return this.colorResolver.resolve(this.qrCodeWidget?.background_color) || 'transparent'
  }

  get colorLight(): string {
    return this.colorResolver.resolve(this.qrCodeWidget?.background_color) || '#ffffff'
  }

  get textColor(): string {
    return this.colorResolver.resolve(this.qrCodeWidget?.color) || ''
  }

  get fontFamily(): string {
    return this.qrCodeWidget?.font_family || ''
  }

  get fontSize(): number {
    return (this.qrCodeWidget?.font_size ?? 16) / 8
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['qrCodeWidget']) {
      this.cdr.markForCheck()
    }
  }

  ngAfterViewInit(): void {
    const qrCodeBodyElement = this.qrCodeBody?.nativeElement
    if (!qrCodeBodyElement) {
      return
    }

    this.updateQrCodeSize(qrCodeBodyElement)

    this.resizeObserver = new ResizeObserver(() => {
      this.updateQrCodeSize(qrCodeBodyElement)
    })
    this.resizeObserver.observe(qrCodeBodyElement)

    this.cdr.detectChanges()
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect()
  }

  private updateQrCodeSize(element: HTMLDivElement): void {
    const nextSize = Math.max(1, Math.floor(Math.min(element.clientWidth, element.clientHeight)))
    if (nextSize === this.qrCodeSize) {
      return
    }

    this.qrCodeSize = nextSize
    this.cdr.markForCheck()
  }
}
